/* @flow weak */
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import Modal from 'components/Modal.jsx';
import React from 'react';

import cx from 'classnames';

import styles from './styles/LoadingModal.css';

const LoadingModal = ({ ...props }) => (
  <Modal {...props} className={cx(styles.this, props.className)}>
    <LoadingIndicator className={styles.loadingIndicator} />
  </Modal>
);

export default LoadingModal;



// WEBPACK FOOTER //
// ./src/components/LoadingModal.jsx